import { Component, OnDestroy, OnInit } from '@angular/core';
import { SharedState } from '@core/store/shared.state';
import { AuthState } from '@core/store/auth/auth.state';
import { environment } from '@env/environment';
import { Select } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap, filter } from 'rxjs/operators';
import { DownloadDialogManagerService } from '@core/services/download-dialog-manager.service';
@Component({
    selector: 'hmt-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  @Select(SharedState.getSpinnerStatus) isSpinnerEnabled: Observable<{spinner: boolean, spinnerMessage: string}>;
  @Select(AuthState.getUser) currentUser$: Observable<any>;
  private unsubscribe: Subject<void> = new Subject();

  spinnerPros: {spinner: boolean, spinnerMessage: string} = {spinner: false, spinnerMessage: ''};

  constructor(
    private downloadDialogManager: DownloadDialogManagerService
  ) {
    this.downloadDialogManager.init();
  }

  ngOnInit(): void {
    this.isSpinnerEnabled
    .pipe(
      tap(result => this.spinnerPros = result),
      takeUntil(this.unsubscribe)
    )
    .subscribe();

  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      try {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = name;
        document.getElementsByTagName('head')[0].appendChild(script);
        console.log('Script Loaded');
        resolve('Ok');
      } catch (e) {
        reject(`Error ${e}`);
      }
    });
  }
  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
